import { lazy } from 'react'
import MainLayout from '../pages/layouts/main/Main.layout'
import type { RouteType } from '../types'
// import { createAuthorityGaurd } from './guards'
// Import { guest } from './guards';
import { path } from './paths'

export const routes: RouteType[] = [
  {
    path: path.LANDING,
    component: lazy(async () => await import('../pages/landing/Landing.page')),
    layout: MainLayout
  },
  {
    path: path.SIGNIN,
    component: lazy(async () => await import('../pages/auth/signin/Signin.page'))
  },
  {
    path: path.SIGNUP,
    component: lazy(async () => await import('../pages/auth/signup/Signup.page'))
  },
  {
    path: path.ACCOUNTSETUP,
    component: lazy(async () => await import('../pages/auth/account-setup/AccountSetup.page'))
  },
  {
    path: path.ABOUT,
    component: lazy(async () => await import('../pages/about-us/AboutUs.page')),
    layout: MainLayout
  },
  {
    path: path.MARKET,
    component: lazy(async () => await import('../pages/market/Market.page')),
    layout: MainLayout
  },
  {
    path: path.ALLPRODUCTS,
    component: lazy(async () => await import('../pages/all-products/AllProducts.page')),
    layout: MainLayout
  },
  {
    path: path.PRODUCTDETAIL,
    component: lazy(async () => await import('../pages/product-detail/ProductDetail.page'))
  },
  {
    path: path.SUPPLIERS,
    component: lazy(async () => await import('../pages/suppliers/Suppliers.page')),
    layout: MainLayout
  },
  {
    path: path.ADMINSUPPLIER,
    component: lazy(async () => await import('../pages/admin/suppliers/Suppliers.page'))
  },
  {
    path: path.HERBSANDSPICES,
    component: lazy(async () => await import('../pages/herbs-and-spices/HerbsAndSpices.page')),
    layout: MainLayout
  },
  {
    path: path.FRUITS,
    component: lazy(async () => await import('../pages/fruits/Fruits.page')),
    layout: MainLayout
  },
  {
    path: path.VEGETABLES,
    component: lazy(async () => await import('../pages/vegetables/Vegetables.page')),
    layout: MainLayout
  },
  {
    path: path.NUTS,
    component: lazy(async () => await import('../pages/nuts/Nuts.page')),
    layout: MainLayout
  },
  {
    path: path.GRAINS,
    component: lazy(async () => await import('../pages/grains/Grains.page')),
    layout: MainLayout
  },
  {
    path: path.LEGUMES,
    component: lazy(async () => await import('../pages/legumes/Legumes.page')),
    layout: MainLayout
  },
  {
    path: path.TUBERS,
    component: lazy(async () => await import('../pages/tubers/Tubers.page')),
    layout: MainLayout
  },
  {
    path: path.BEVERAGES,
    component: lazy(async () => await import('../pages/beverages/Beverages.page')),
    layout: MainLayout
  },
  {
    path: path.TERREBASICS,
    component: lazy(async () => await import('../pages/terre-basics/TerreBasics.page')),
    layout: MainLayout
  },
  {
    path: path.CONTACT,
    component: lazy(async () => await import('../pages/contact-us/ContactUs.page')),
    layout: MainLayout
  },
  {
    path: path.BLOG,
    component: lazy(async () => await import('../pages/blog/Blog.page')),
    layout: MainLayout
  },
  {
    path: path.CULTIVATION,
    component: lazy(async () => await import('../pages/cultivation/Cultivation.page')),
    layout: MainLayout
  },
  // {
  //   path: path.LOGIN,
  //   component: lazy(async () => await import('../pages/auth/login/Login.page')),
  //   guards: []
  // },
  // {
  //   path: path.USERPROFILEFORM,
  //   component: lazy(async () => await import('../pages/auth/UserProfileForm/UserProfileForm.page')),
  //   guards: [createAuthorityGaurd(['user.*'])]
  // },
  {
    path: path.TERMS_OF_SERVICE,
    component: lazy(async () => await import('../pages/terms-of-service/TermsOfService.page')),
    layout: MainLayout
  },
  {
    path: path.REGISTER,
    component: lazy(async () => await import('../pages/auth/register/Register.page')),
    guards: []
  },
  {
    path: path.FILE_UPLOAD,
    component: lazy(async () => await import('../components/FileUpload/FileUpload.component')),
    guards: []
  },
  {
    path: path.NETWORK_ERROR,
    component: lazy(async () => await import('../pages/error/network.page'))
  },
  {
    path: path.VALIDATE_EMAIL,
    component: lazy(async () => await import('../pages/verifyEmail/VerifyEmail.page'))
  },
  // This should be the last entry, for some reason I prefer it to be so
  {
    path: '*',
    component: lazy(async () => await import('../pages/error/notfound.page')),
    layout: MainLayout
  }
]
